import { useState, useEffect } from "react";

const Snackbar = ({ message, type, duration, onClose ,alertMessage,setAlertMessage}) => {
    // const [visible, setVisible] = useState(false);
   
    useEffect(() => {

        const timer = setTimeout(() => {
            setAlertMessage(false);
            // setTimeout(onClose, 800); // Allow fade-out animation before removing
        }, duration);
        return () => clearTimeout(timer);
    }, [duration, onClose]);

    if (!alertMessage) return null;

    return (
        <div
            style={{
                position: "absolute",
                top: "10%",
                left: "50%",
                transform: "translateX(-50%)",
                background: getColor(type),
                color: "red",
                padding: "12px 24px",
                borderRadius: "5px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                opacity: alertMessage ? 1 : 0,
                transition: "opacity 0.3s ease-in-out",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                zIndex: 999
            }}
        >
            <span>{message}</span>
            <button
                onClick={() => setAlertMessage(false)}
                style={{
                    background: "transparent",
                    border: "none",
                    color: "rgb(223, 24, 130)",
                    fontSize: "16px",
                    cursor: "pointer",
                }}
            >
                ✖
            </button>
        </div>
    );
};

const getColor = (type) => {
    switch (type) {
        case "success":
            return "#4CAF50";
        case "error":
            return "#F44336";
        case "warning":
            return "#FFC107";
        case "info":
            return "#fdeded";
        default:
            return "#2196F3";
    }
};

export default Snackbar;
